<template>
    <div>
        <p class="font-weight-bold"> Communication </p>
        <div class="row text-small">
            <div class="col-sm-5">
                <table class="table table-sm" id="communicationTable" v-if="vessel.communication">
                    <tbody>
                    <tr>
                        <th scope="row" class="align-middle">Call Sign</th>
                        <td class="align-middle">{{vessel.communication.callSign}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Email</th>
                        <td class="align-middle">{{vessel.communication.email}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Radio Telex</th>
                        <td class="align-middle">{{vessel.communication.radioTelex}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">MMSI No.</th>
                        <td class="align-middle">{{vessel.communication.mmsiNo}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">NTT Phone</th>
                        <td class="align-middle">{{vessel.communication.nntPhone}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Radio Acc. Authority</th>
                        <td class="align-middle">{{vessel.communication.radioAccAuthority}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Radio Acc. Code</th>
                        <td class="align-middle">{{vessel.communication.radioAccCode}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Sat B</th>
                        <td class="align-middle">{{vessel.communication.satB}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Sat C</th>
                        <td class="align-middle">{{vessel.communication.satC}}</td>
                    </tr>
                    <tr>
                        <th scope="row" class="align-middle">Fax</th>
                        <td class="align-middle">{{vessel.communication.fax}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { vueAppMixin} from "@/mixins/vueAppMixin";
import { gateMixin} from "@/mixins/gateMixin";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "VesselCommunication",
    mixins: [ vueAppMixin, gateMixin],
    methods: {
        ...mapActions([  ]),
    },

    computed: {
        ...mapGetters([ 'vessel' ]),

    },
}
</script>

<style scoped>

</style>
